import {AxiosError} from 'axios';
import {PUT_UPDATE_COORDINATOR_PROFILE_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutUpdateCoordinatorProfile = ({onError, onSuccess, uuid}: Input) => {
  const putUpdateCoordinatorProfile = async (reqBody: any) => {
    const res = await axiosClient.put<void>(PUT_UPDATE_COORDINATOR_PROFILE_URL(uuid), reqBody);

    return res.data;
  };

  return useCustomMutation(putUpdateCoordinatorProfile, {
    onSuccess,
    onError,
  });
};
